import { Caption } from '@farol-ds/react'
import { ReactNode } from 'react'

import styles from './info-source-disclaimer.module.scss'

export type InfoSourceDisclaimerProps = {
  title: string
  children: ReactNode
  className?: string
}

export function InfoSourceDisclaimer(props: InfoSourceDisclaimerProps) {
  const { title, children, className } = props
  return (
    <div className={className}>
      <p className={styles.title}>{title}</p>
      <Caption>{children}</Caption>
    </div>
  )
}
